<template>
	<div style="padding: 0px;">
		<div>
			<div style="min-width: 120px;float: right;margin-right: 20px;">
				<el-button type="primary" icon="el-icon-plus" @click="addOrgPoint">添加点位关联</el-button>
			</div>
		</div>
		<div style="margin-top: 10px;">
			<el-table :data="sysOrgPointsList"  style="width: 100%"  max-height="500">
				<el-table-column prop="orgname" label="所属组织" align="center"></el-table-column>
			    <el-table-column prop="pointname" label="点位名称" align="center"></el-table-column>
				<el-table-column prop="objectid" label="objectid" align="center"></el-table-column>
				<el-table-column prop="caclid" label="propertyid" align="center"></el-table-column>
				<el-table-column prop="iconurl" label="图标" align="center"></el-table-column>
				<el-table-column prop="idx" label="排序" align="center"></el-table-column>
				<el-table-column prop="defaultshow" label="默认显示"  align="center">
					<template slot-scope="scope">
						<el-tag v-if="'Y' == scope.row.defaultshow" type="success">显示</el-tag>
						<el-tag v-else  type="info" >不显示</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="homepageshow" label="首页显示"  align="center">
					<template slot-scope="scope">
						<el-tag v-if="'Y' == scope.row.homepageshow" type="success">显示</el-tag>
						<el-tag v-else  type="info" >不显示</el-tag>
					</template>
				</el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="180" align="center">
					<template slot-scope="scope">
						<a @click="deleteLocPoint(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="orgPointTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashRelData" append-to-body :destroy-on-close="true" title="添加关联点位" width="70%" :visible.sync="addrelshow">
			<AddOrgPoint @needRelRefrash="needRelRefrash" :add="true" :selectedorg="selectedorg" :selectedorgpoint="selectset"></AddOrgPoint>
		</el-dialog>
	</div>
</template>

<script> 
	import { queryOrgCalcPointsByPage, deleteOrgCalcRel } from '/static/apiUrl.js'
	import AddOrgPoint from './addorgpoint'
	export default {
		name : 'OrgPoint',
		data() {
			return {
				addrelshow : false,
				editok : false,
				selectset : null,
				sysorginfo : {
					id: "",
					name: ""
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				orgPointTotal : 0,
				sysOrgPointsList : [],
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		components: {
			AddOrgPoint,
		},
		props: {
			selectedorg: {
				type: Object,
				required: true
			},
		},
		watch: {
			selectedorg: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.sysorginfo.id = newVal.id
						this.sysorginfo.name = newVal.name
						this.queryOrgPointList()
					}else{
						this.sysorginfo.id = ""
						this.sysorginfo.name = ""
					}
				}
			},
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryOrgPointList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryOrgPointList()
			},
			queryOrgPointList(){
				this.sysOrgPointsList = []
				queryOrgCalcPointsByPage({
					oid : this.sysorginfo.id,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					if(0 == res.code){
						this.orgPointTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysOrgPointsList.push(set)
						})
					}
				})
			},
			deleteLocPoint(idx,row){
				this.$confirm('此操作将删除组织绑定的点位 '+this.sysOrgPointsList[idx].pointname+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteOrgCalcRel({
						id : this.sysOrgPointsList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryOrgPointList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			needRelRefrash(val,isshow){
				this.editok = val
				this.addrelshow = isshow
			},
			refrashRelData() {
				if(this.editok){
					this.queryOrgPointList()
				}
			},
			addOrgPoint(){
				this.addrelshow = true
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>